import { render } from "./ClaimBlocs.vue?vue&type=template&id=44c6852c"
import script from "./ClaimBlocs.vue?vue&type=script&lang=js"
export * from "./ClaimBlocs.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\mfeys\\Desktop\\HAv2\\actions\\19612-frontline\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__